import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import ModuleSlider from '../components/map/ModuleSlider';
import { useLoading } from '../contexts/LoadingContext';
import { getAuthToken, getClientType } from '../services/clientConfig';

function SimFix() {
  const location = useLocation();
  const { showLoader, hideLoader } = useLoading();

  React.useEffect(() => {
    showLoader('Caricamento simulazione...');
    return () => hideLoader();
  }, []);

  // Build the iframe URL with auth token and query parameters from URL
  const iframeSrc = useMemo(() => {
    const baseUrl = process.env.REACT_APP_SIMFIX_LINK;
    const authToken = getAuthToken();
    const clientType = getClientType();

    // Start with auth token
    const params = new URLSearchParams();
    if (authToken) {
      params.set("auth_token", authToken);
    }

    // Pass client_type parameter
    if (clientType && clientType !== 'default') {
      params.set("client_type", clientType);
    }

    // Pass scenario and node parameters from current URL
    const urlParams = new URLSearchParams(location.search);
    const scenario1 = urlParams.get("scenario_1");
    const scenario2 = urlParams.get("scenario_2");
    const node1 = urlParams.get("node_1");
    const node2 = urlParams.get("node_2");

    if (scenario1) params.set("scenario_1", scenario1);
    if (scenario2) params.set("scenario_2", scenario2);
    if (node1) params.set("node_1", node1);
    if (node2) params.set("node_2", node2);

    return `${baseUrl}?${params.toString()}`;
  }, [location.search]);

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <iframe
        src={iframeSrc}
        style={{ width: "100%", height: "100%", border: "none" }}
        title="SimFix"
        onLoad={() => hideLoader()}
      />

      {/* Module Slider - Navigation between modules */}
      <ModuleSlider
        showNavbarControls={false}
        setShowNavbarControls={() => {}}
        showSimfixAreas={false}
        setShowSimfixAreas={() => {}}
        showPredictMode={false}
        setShowPredictMode={() => {}}
        showTlGreenWave={false}
        setShowTlGreenWave={() => {}}
        showAssignx={false}
        setShowAssignx={() => {}}
      />
    </div>
  );
}

export default SimFix;
